import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import superAdminTheme from '../../shared/components/data-table/superadmin-theme';
import DataTable from '../../shared/components/data-table/DataTable';
import StateBlock from '../../shared/components/data-table/StateBlock';
import useProgramCertificatesHook from './useProgramCertificatesHook';
import BulkActionBar from './components/bulk-action-bar';
import ConfirmGenerateModal from './components/confirm-generate-modal';

const ProgramCertificates = () => {
  const {
    columns,
    rows,
    loading,
    bulkLoading,
    page,
    pageSize,
    totalCount,
    pageSizeOptions,
    selectedRows,
    confirmState,
    setConfirmState,
    handleGenerateBulk,
    handleConfirmGenerate,
    onPageChange,
    onPageSizeChange,
    clearSelection,
    refreshResults,
  } = useProgramCertificatesHook();

  const emptyState = (
    <StateBlock
      variant="empty"
      title="No pending certificates"
      description="All eligible learners already have program certificates."
      data-testid="program-certificates-empty-results"
    />
  );

  return (
    <ThemeProvider theme={superAdminTheme}>
      <Box
        sx={{ p: { xs: 2, md: '24px 32px' }, height: '100%', width: '100%', backgroundColor: 'common.white', overflow: 'auto' }}
        data-testid="program-certificates-page"
      >
        <Box mb={2}>
          <Typography variant="h1" sx={{ color: 'text.primary' }}>
            Pending Certificates
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Learners who completed programs but do not yet have a program certificate.
          </Typography>
        </Box>

        <BulkActionBar
          selectedCount={selectedRows.length}
          loading={bulkLoading}
          onGenerate={handleGenerateBulk}
          onClearSelection={clearSelection}
        />

        <DataTable
          columns={columns}
          rows={rows}
          loading={loading}
          getRowId={(row) => row.id}
          paginationMode="server"
          page={page}
          pageSize={pageSize}
          pageSizeOptions={pageSizeOptions}
          totalCount={totalCount}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          onRefresh={refreshResults}
          emptyState={emptyState}
          data-testid="program-certificates-table"
        />

        <ConfirmGenerateModal
          open={Boolean(confirmState)}
          title={confirmState?.title || ''}
          message={confirmState?.message || ''}
          confirmLabel={confirmState?.confirmLabel || 'Generate'}
          loading={bulkLoading}
          onCancel={() => setConfirmState(null)}
          onConfirm={handleConfirmGenerate}
        />
      </Box>
    </ThemeProvider>
  );
};

export default ProgramCertificates;
